module.exports = __webpack_public_path__ + "static/media/Shahad.59ef5248.jpg";